import Point from '../../Utility/Point';
import Component from '../Component';
import TransformComponent from '../Transform';
import PIXIRenderer from '../../System/Render/PIXIRenderer';
import ObservablePoint from '../../Utility/ObservablePoint';
import RenderSystem, {
    RenderSystemEvent,
} from '../../System/Render/RenderSystem';
import { defaultCanvasSize } from '../../Constants/Canvas';

export default class RelativePositionComponent extends Component {
    private _relativePosition: ObservablePoint = new ObservablePoint(
        () => {
            this.updatePosition();
        },
        this,
        0,
        0
    );

    public get relativePosition(): Point | ObservablePoint {
        return this._relativePosition as Point | ObservablePoint;
    }

    public set relativePosition(value: Point | ObservablePoint) {
        this._relativePosition.set(value.x, value.y);
        this.updatePosition();
    }

    public get x(): number {
        return this._relativePosition.x;
    }

    public get y(): number {
        return this._relativePosition.y;
    }

    public set x(x: number) {
        this._relativePosition.x = x;
        this.updatePosition();
    }

    public set y(y: number) {
        this._relativePosition.y = y;
        this.updatePosition();
    }

    protected onAttach(): void {
        RenderSystem.on(
            RenderSystemEvent.RESIZE,
            this.updatePosition.bind(this)
        );
    }

    protected onDetach(): void {
        RenderSystem.off(
            RenderSystemEvent.RESIZE,
            this.updatePosition.bind(this)
        );
    }

    private updatePosition(): void {
        if (this.gameObject) {
            const transform = this.gameObject.getComponent(TransformComponent);

            const yOffset: number = Math.max(
                0,
                (PIXIRenderer.renderer.height - defaultCanvasSize.y) / 2
            );

            transform.offset.set(
                PIXIRenderer.renderer.width * this._relativePosition.x,
                yOffset + defaultCanvasSize.y * this._relativePosition.y
            );
            transform.position.set(transform.x + 1, transform.y);
            transform.position.set(transform.x - 1, transform.y);
        }
    }
}
